/**
 * Set when retailer has seen referral reengagement banner *
 */ export var HAS_SEEN_REFERRAL_REENGAGEMENT_BANNER = 'HAS_SEEN_REFERRAL_REENGAGEMENT_BANNER';
